import { useTheme } from "./useTheme.ts";
import type { RevealMode } from "../providers/themeProvider.tsx";

/** Thin wrapper around useTheme exposing only the reveal-characters preference. */
export function useRevealChars(): {
  revealMode: RevealMode;
  setRevealMode: (m: RevealMode) => void;
  revealTextarea: boolean;
  setRevealTextarea: (on: boolean) => void;
} {
  const { revealMode, setRevealMode, revealTextarea, setRevealTextarea } = useTheme();
  return { revealMode, setRevealMode, revealTextarea, setRevealTextarea };
}

/** Thin wrapper around useTheme exposing only the "Trim spaces on save" preference. */
export function useAutoTrim(): { autoTrim: boolean; setAutoTrim: (on: boolean) => void } {
  const { autoTrim, setAutoTrim } = useTheme();
  return { autoTrim, setAutoTrim };
}
